// A client-side QR code image. The URL is encoded entirely in the browser (an unguessable
// token never goes to a third-party QR service). Shows a brief "Generating..." state and a
// plain fallback if rendering fails. Shared across the office app.
import { useEffect, useState } from "react";
import QRCode from "qrcode";

export function QrImage({ url, size = 232 }: { url: string; size?: number }) {
  const [src, setSrc] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let live = true;
    setSrc(null);
    setFailed(false);
    QRCode.toDataURL(url, { width: size, margin: 1 }).then(
      (d) => {
        if (live) setSrc(d);
      },
      () => {
        if (live) setFailed(true);
      },
    );
    return () => {
      live = false;
    };
  }, [url, size]);
  if (failed) return <p className="p-8 text-sm text-ele-bg">Could not render the QR code.</p>;
  if (!src) return <p className="p-8 text-sm text-ele-bg">Generating...</p>;
  return <img src={src} alt="RFID service page QR code" width={size} height={size} />;
}
